import { render, staticRenderFns } from "./ledger_detail_pc.vue?vue&type=template&id=6e200214&scoped=true&"
import script from "./ledger_detail_pc.vue?vue&type=script&lang=js&"
export * from "./ledger_detail_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e200214",
  null
  
)

export default component.exports